import { Box } from '@mui/material';
import ProcessPendingBloc from 'components/common/ProcessPendingBloc';
import useStyles from 'style/js-style/components/thirdparties/securityRating/SecurityRatingStyle';

const SecurityRatingInProgress = () => {
	const { classes } = useStyles();

	return (
		<Box className={classes.rootNoData}>
			<ProcessPendingBloc duration='minutes'/>
		</Box>
	);
};

export default SecurityRatingInProgress;
